<template>
  <div class>
    <el-form inline ref="form" size="small" :model="form" label-width="80px" @submit.native.prevent>
      <el-form-item v-if="btns.addMem">
        <el-button type="info" icon="el-icon-plus" @click="addMemBerDialog=true">添加成员</el-button>
      </el-form-item>
      <el-form-item v-if="btns.delMem">
        <el-button plain @click="deleteMem">删除成员</el-button>
      </el-form-item>
      <el-form-item label>
        <el-input
          style="width:270px"
          class="selectInput"
          size="small"
          @keyup.enter.native="search"
          v-model="searchText"
          placeholder="账号/坐席昵称/使用者/手机号/角色"
        >
          <svg slot="suffix" class="icon" aria-hidden="true" @click="search">
            <use xlink:href="#iconsearchicon" />
          </svg>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table ref="skillGroupMemTable" :data="tableData" style="width: 100%">
      <el-table-column align="center" type="selection" width="55"></el-table-column>
      <el-table-column align="center" prop="groupName" label="坐席组" width="180"></el-table-column>
      <el-table-column align="center" prop="userName" label="账号" width="180"></el-table-column>
      <el-table-column align="center" prop="nickname" label="坐席昵称" width="180"></el-table-column>
      <el-table-column align="center" prop="realName" label="使用者"></el-table-column>
      <el-table-column align="center" prop="mobile" label="手机号"></el-table-column>
      <el-table-column align="center" prop="roleName" label="角色"></el-table-column>
    </el-table>
    <!-- 底部分页栏 -->
    <el-row style="float:right;">
      <el-pagination
        background
        class="pageStyle"
        layout="total, prev, pager, next, jumper"
        :page-size.sync="pageSize"
        :current-page.sync="pageNum"
        :total="total"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </el-row>
    <!-- 添加成员 -->
    <el-dialog title="添加成员" width="480px" :destroy-on-close="true" :visible.sync="addMemBerDialog">
      <div class="block-fixedwidth">
        <div style="margin-bottom:20px;text-align:center">
          <TreeSelect
            class="filter-tree"
            :multiple="true"
            :data="storeUserGroupData"
            :defaultProps="grouptreeProp"
            :multipleChange="multipleChange"
            ref="tree"
            size="medium"
          ></TreeSelect>
        </div>
        <div class="dialog-footer" style="text-align:center;margin-bottom:20px;">
          <el-button size="medium" @click="addMemBerDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" @click="confirmAddMem">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TreeSelect from '@/views/auth/components/treeSelect/TreeSelect'
import { addSkillGroupMem, listSkillGroupUser, deleteSkillGroupMember } from '@/api/user'
export default {
  name: 'MemberTable',
  data() {
    return {
      addMemBerDialog: false,
      currentPage: 1,
      searchText: '',
      form: {},
      addMemdata: [],
      tableData: [],
      grouptreeProp: {
        children: 'children',
        label: 'name'
      },
      btns: {
        addMem: false,
        delMem: false
      },
      // 分页参数
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  props: [],
  components: {
    TreeSelect
  },
  watch: {
    storeClickSkillGroupId(val) {
      this._listSkillGroupUser({ skillId: val, searchText: this.searchText })
      this.showBtnAddMem()
      this.showBtnDelMem()
    }
  },
  computed: {
    storeUserGroupData() {
      return this.$store.state.user.userGroupData
    },
    storeClickSkillGroupId() {
      return this.$store.state.user.clickSkillGroup.id
    },
    storeDegaultSGId() {
      // 默认技能组
      return this.$store.state.skill.defaultSkillGroupId
    }
  },
  mounted() {
    this._listSkillGroupUser({ skillId: this.storeClickSkillGroupId, searchText: this.searchText })
  },
  methods: {
    // 分页栏点击事件
    handleCurrentChange(val) {
      this.pageNum = val
      this._listSkillGroupUser({
        skillId: this.storeClickSkillGroupId,
        searchText: this.searchText
      })
    },
    showBtnAddMem() {
      this.btns.addMem =
        this.storeClickSkillGroupId !== this.storeDegaultSGId &&
        this.$authUtis.hasButtonAuth('aicc-bp', '/skill/addSkillGroupMem_post')
    },
    showBtnDelMem() {
      this.btns.delMem =
        this.storeClickSkillGroupId !== this.storeDegaultSGId &&
        this.$authUtis.hasButtonAuth('aicc-bp', '/skill/deleteSkillGroupMember_delete')
    },
    search() {
      this._listSkillGroupUser({
        skillId: this.storeClickSkillGroupId,
        searchText: this.searchText
      })
    },
    confirmAddMem() {
      addSkillGroupMem({ skillId: this.storeClickSkillGroupId, memberIds: this.addMemdata }).then(
        res => {
          if (res.code === 2000) {
            this._listSkillGroupUser({
              skillId: this.storeClickSkillGroupId,
              searchText: this.searchText
            })
            this.addMemBerDialog = false
            this.$message.success(res.data)
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    _listSkillGroupUser({ skillId, searchText }) {
      listSkillGroupUser({
        skillId,
        searchText,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 2000) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    deleteMem() {
      const selected = this.$refs.skillGroupMemTable.selection
      if (!selected || selected.length === 0) {
        this.$message.error('请先勾选成员')
        return
      }
      this.$confirm('是否删除成员？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      })
        .then(() => {
          deleteSkillGroupMember({ rows: selected, skillId: this.storeClickSkillGroupId })
            .then(res => {
              if (res.code === 2000) {
                this._listSkillGroupUser({
                  skillId: this.storeClickSkillGroupId,
                  searchText: this.searchText
                })
                this.$message.success(res.data)
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    multipleChange(data) {
      this.addMemdata = data
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
